<template>
  <div class="padding">
    <div class="row">
      <div class="col-sm-6">
        <div class="m-b-sm">
          <h5 class="m-b-md _300">Suppliers</h5>
        </div>
      </div>
    </div>

    <div class="clearfix"/>

    <div class="row">
      <div class="col-xs-12">
        <div class="box">
          <v-server-table 
            ref="datatable" 
            :url="api" 
            :name="tableName" 
            :columns="columns" 
            :options="options"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        var that = this;

        return {
            supplier: {},
            tableName: 'VUETABLE_SUPPLIER',
            columns: [
                'name',
                'city',
                'country',
                'contact_name',
                'contact_no',
                'contact_email',
            ],
            options: {
                headings: {
                    name: 'Supplier Name',
                    contact_name: 'Contact Person',
                    contact_no: 'Phone No.',
                    contact_email: 'Email',
                },
                permission: {
                    create: () => this.permission.SAVE_SUPPLIER,
                    delete: () => this.permission.DELETE_SUPPLIER,
                },
                checkbox: {
                    api_delete: Laroute.route('supplier.delete'),
                    delete_title: 'Delete Supplier',
                },
                create_btn: {
                    title: 'New Supplier',
                    action: () => {
                        this.$router.push('/create');
                    },
                },
                rowClassCallback: row => 'pointer',
                rowClickCallback: row => {
                    this.$router.push(`/${row.id}`);
                },
                csv_url: Laroute.route('supplier.export', { type: 'csv' }),
                pdf_url: Laroute.route('supplier.export', { type: 'pdf' }),
                xls_url: Laroute.route('supplier.export', { type: 'xlsx' }),
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('supplier.getSupplierDatatable');
        },
    },

    created() {},
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/supplier/supplier-list.vue